import { scaleLinear } from 'd3-scale';
import { select } from 'd3-selection';
import { annotation as d3_annotation } from 'd3-svg-annotation';
import * as fc from 'd3fc';
export default function svgAnnotation() {
    let xScale = scaleLinear();
    let yScale = scaleLinear();
    const join = fc.dataJoin('g', 'annotation');
    const annotation = d3_annotation();
    const _annotation = (sel) => {
        sel.each((data, i, group) => {
            const scaledData = data.map((d) => (Object.assign(Object.assign({}, d), { x: xScale(d.x), y: yScale(d.y) })));
            annotation.annotations(scaledData);
            join(select(group[i]), scaledData).call(annotation);
        });
    };
    _annotation.xScale = (...args) => {
        if (args.length === 0)
            return xScale;
        xScale = args[0];
        return _annotation;
    };
    _annotation.yScale = (...args) => {
        if (args.length === 0)
            return yScale;
        yScale = args[0];
        return _annotation;
    };
    fc.rebindAll(_annotation, annotation);
    return _annotation;
}
